import React, {ReactElement} from "react";
import {Typography} from "antd";
import "../DynamicForm.scss";
import {AnyElementValue, LiteralElementProps} from "@data-force/app";
import MarkdownMedia from "../../Markdown/MarkdownMedia";

const LiteralElement: React.FC<LiteralElementProps> = (props: LiteralElementProps): ReactElement => {
    const {value, className = "", signType}: LiteralElementProps = props;

    const displayValue: ReactElement | AnyElementValue = typeof value === "string"
        ? (
            <MarkdownMedia signType={signType}>
                {value as string}
            </MarkdownMedia>
        )
        : value;

    return (
        <Typography.Text className={className}>
            {displayValue}
        </Typography.Text>
    );
};

export default LiteralElement;
